import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    display: flex;
    justify-content: center;
    position: sticky;
    bottom: 0;
    z-index: 9;
  `,
  navigation: css`
    width: 100%;
    border-top: 0.5px solid ${colors.prussian400};
    height: 94px !important;
    align-items: flex-start !important;
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0px 0px -1px, rgba(0, 0, 0, 0.15) 0px -2px 4px 0px,
      rgba(0, 0, 0, 0.04) 0px 3px 3px -1.5px, rgba(0, 0, 0, 0.04) 0px 5px 2px -4px,
      rgba(0, 0, 0, 0.04) 0px -3px 8px 3px, rgba(0, 0, 0, 0.04) 0px 24px 24px -12px;
    @media (min-width: 800px) {
      max-width: 812px;
      height: 88px !important;
    }
  `,
  action: css`
    font-size: ${pxToRem(12)} !important;
    line-height: 1.33;
    letter-spacing: -0.3px;
    &.MuiBottomNavigationAction-root {
      height: 100%;
      font-family: 'Montserrat Medium' !important;
      min-width: auto;
      color: ${colors.slate};
    }

    & > .MuiBottomNavigationAction-label {
      font-size: ${pxToRem(12)} !important;

      @media (min-width: 800px) {
        font-size: ${pxToRem(14)}!important;
      }
      &.Mui-selected {
        font-family: 'Montserrat SemiBold' !important;
        color: ${colors.prussian};
        font-weight: 600;
      }
    }
  `,
};

export default styles;
